import React from 'react';

import { FeatureFlags } from '~src/ts/FeatureFlags';
import { Messages } from '../../codegen/Localize';
import { PermissionsGridStyles } from '../styles/PermissionsGridStyle';

export const NO_RESULTS_TEXT_TESTID = 'permissions-no-results';
export const NO_PERMISSION_RULES_TEXT_TESTID = 'permissions-no-rules';

export interface PermissionsGridEmptyStateProps {
  isDisabled: boolean;
  isEditable: boolean;
  isEmpty: boolean;
  isExplicitPermissions: boolean; // true for explicit permissions grid, false for effective permissions grid
}

export class PermissionsGridEmptyState extends React.PureComponent<PermissionsGridEmptyStateProps, {}>{

  private shouldRender = (): boolean => {
    // Previously only effective permissions grid can have empty state because explicit permissions grid
    // always has at least one row for All Users group, but when collectionsPermissionsEnabled is on,
    // both grids can have empty state. 
    if (FeatureFlags.collectionsPermissionsEnabled) {
      return this.props.isExplicitPermissions ? this.props.isEmpty && !this.props.isDisabled : this.props.isEmpty;
    } else {
      return !this.props.isExplicitPermissions && this.props.isEmpty;
    }
  }

  private effectivePermissionsGridEmptyState = (): JSX.Element => {
    return (
      <div className={PermissionsGridStyles.effectivePermissionsGridEmptyStateStyle}
           data-tb-test-id={NO_RESULTS_TEXT_TESTID}>
        { Messages.effectivePermissionsNoResultsMsg() }
      </div>
    );
  }

  private explicitPermissionsGridEmptyState = (): JSX.Element => {
    const emptyStateMessage = this.props.isEditable
        ? Messages.permissionRulesEmptyStateMsg()
        : Messages.permissionRulesNotEditableEmptyStateMsg();
    return (
      <div className={PermissionsGridStyles.explicitPermissionsGridEmptyStateStyle}
           data-tb-test-id={NO_PERMISSION_RULES_TEXT_TESTID}>
        { emptyStateMessage }
      </div>
    );
  }

  public render() {
    if (this.shouldRender()) {
      return this.props.isExplicitPermissions
        ? this.explicitPermissionsGridEmptyState()
        : this.effectivePermissionsGridEmptyState();
    } else {
      return null;
    }
  }
}
